import axios from 'axios';
import { queryClient } from '#client/utils/queryClient.js';

const API_URL = import.meta.env.VITE_API_URL;

// Store Query Options
const storeQueryOptions = {
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
};

const getStoreQueryOptions = (id) => ({
    queryKey: ['store', id],
    enabled: !!id,
    ...storeQueryOptions,
});

export const storesService = {
    async fetchStore(id) {
        const response = await queryClient.fetchQuery({
            ...getStoreQueryOptions(id),
            queryFn: async () => {
                const response = await axios.get(`${API_URL}/api/store-locations?id=${id}`);
                return response.data.data.location;
            },
        });

        return response;
    },
};
